export default class EventBusNamespace {
  static SEARCH = 'SEARCH'
}
